import { authConstants } from '../constants';
import { authService } from '../../services';
import { alertActions } from './';
import { history } from '../../helpers';
import Swal from 'sweetalert2';
import { handleErrorInApi } from '../../helpers/response';
import { constants } from '../../Constants';

export const authActions = {
	login,
	logout,
	register,
	forgotPasswordEmail,
	newPassword,
	changePassword,
	getUserData,
	getOnBoardingStatus,
};
function newPassword(password1, password2, code) {
	return (dispatch) => {
		authService.newPassword(password1, password2, code).then((res) => {
			if (res.ok === true) {
				res.json().then((response) => {
					history.replace('/passwordchanged');
				});
			} else if (res.ok === false || res.status === 400) {
				res.json().then((err) => {
					let possible_errors = ['error', '0', 'password1', 'password2'];
					if (err) {
						for (var key in err) {
							if (possible_errors.includes(key)) {
								dispatch(alertActions.error(err[key]));
							}
						}
					}
				});
			}
		});
	};
}

function changePassword(oldpassword, newpassword) {
	return (dispatch) => {
		authService.changePassword(oldpassword, newpassword).then((res) => {
			if (res.ok === true) {
				res.json().then((response) => {
					Swal.fire({
						title: constants.SAAYA_HEALTH_TXT,
						text: constants.PASSWORD_CHANGED_SUCCESS_TXT,
						icon: constants.SUCCESS_TEXT,
						confirmButtonText: constants.OK_TXT
					  });
					  
				});
			} else if (res.ok === false) {
				res.json().then((error) => {
					if (error.new_password) {
						dispatch(alertActions.error(error.new_password[0]));
						Swal.fire({
							title: constants.SAAYA_HEALTH_TXT,
							text: `${error.new_password}`,
							icon: constants.ERROR_TEXT,
							confirmButtonText: constants.OK_TXT
						});
					}
					if (error.old_password) {
						dispatch(alertActions.error(error.old_password));
						Swal.fire({
							title: constants.SAAYA_HEALTH_TXT,
							text: `${error.old_password}`,
							icon: constants.ERROR_TEXT,
							confirmButtonText: constants.OK_TXT
						  });
					}
				});
			}
		});
	};
}

function forgotPasswordEmail(email_address) {
	return (dispatch) => {
		dispatch(request({ email_address }));
		authService.forgotPassword(email_address).then(
			(res) => {
				if (res.ok === true) {
					res.json().then((response) => {
						dispatch(success(response));
						Swal.fire({
							title: constants.EMAIL_SENT_TITLE_TXT,
							text: constants.EMAIL_SENT_MESSAGE_TXT,
							icon: constants.SUCCESS_TEXT,
							confirmButtonText: constants.OK_TXT
						  });
						  
						history.replace('/confirmation/forgotpassword', { email: email_address });
					});
				} else if (res.ok === false) {
					res.json().then((error) => {
						dispatch(failure(error));
						Swal.fire({
							title: constants.EMAIL_NOT_REGISTERED_TXT,
							text: constants.EMAIL_NOT_REGISTERED_TXT,
							icon: constants.ERROR_TEXT,
							confirmButtonText: constants.OK_TXT
						});
						dispatch(alertActions.error(error.Error));
					});
				}
			},
			(error) => {
				dispatch(alertActions.error(handleErrorInApi()));
			}
		);
	};

	function request(user) {
		Swal.showLoading();
		return { type: authConstants.FORGOTPASSWORD_REQUEST, user };
	}
	function success(response) {
		Swal.hideLoading();
		return { type: authConstants.FORGOTPASSWORD_SUCCESS, response };
	}
	function failure(error) {
		Swal.hideLoading();
		return { type: authConstants.FORGOTPASSWORD_FAILURE, error };
	}
}

function login(email_address, password) {
	return (dispatch) => {
		dispatch(request({ email_address }));
		authService.login(email_address, password).then(
			(resp) => {
				if (resp.ok === true) {
					resp.json().then((user) => {
						if (user.response) {
							dispatch(alertActions.error(user.response));
						} else if (user.token) {
							dispatch(success(user));
							localStorage.setItem('user', JSON.stringify(user));
							sessionStorage.setItem('token', user.token);
							localStorage.setItem('token', JSON.stringify(user.token));
							sessionStorage.setItem('role', '2');
								history.replace('/home');
							
						}
					});
				} else if (resp.ok === false) {
					resp.json().then((err) => {
						let possible_errors = ['username', 'password1', 'non_field_errors', 'email_address','response'];
						for (var key in err) {
							if (possible_errors.includes(key)) {
								dispatch(failure(err[key]));
								dispatch(alertActions.error(err[key]));
							}
						}
					});
				}
			},
			(error) => {
				dispatch(failure(error.toString()));
				dispatch(alertActions.error(handleErrorInApi()));
			}
		);
	};

	function request(user) {
		return { type: authConstants.LOGIN_REQUEST, user };
	}
	function success(user) {
		return { type: authConstants.LOGIN_SUCCESS, user };
	}
	function failure(error) {
		return { type: authConstants.LOGIN_FAILURE, error };
	}
}

function logout() {
	authService.logout();
	return { type: authConstants.LOGOUT };
}

function register(user) {
	return (dispatch) => {
		dispatch(request(user));
		authService.register(user).then(
			(resp) => {
				if (resp.ok === true) {
					dispatch(success(user));
					history.push('/confirmation');
				} else if (resp.ok === false) {
					resp.json().then((err) => {
						let possible_errors = [
							'username',
							'password1',
							'password2',
							'non_field_errors',
							'email_address',
						];
						for (var key in err) {
							if (possible_errors.includes(key)) {
								dispatch(failure(err[key][0]));
								dispatch(alertActions.error(err[key][0]));
							}
						}
					});
				}
			},
			(error) => {
				dispatch(failure(error.toString()));
				dispatch(alertActions.error(handleErrorInApi()));
			}
		);
	};
	function request(user) {
		return { type: authConstants.REGISTER_REQUEST, user };
	}
	function success(user) {
		return { type: authConstants.REGISTER_SUCCESS, user };
	}
	function failure(error) {
		return { type: authConstants.REGISTER_FAILURE, error, user };
	}
}

function getUserData() {
	return (dispatch) => {
		dispatch(request());
		authService.getUserData().then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: authConstants.GET_USER_DATA_REQUEST };
	}
	function success(user) {
		localStorage.removeItem('user');
		localStorage.setItem('user', JSON.stringify(user));
		return {
			type: authConstants.GET_USER_DATA_SUCCESS,
			user,
		};
	}
	function failure(user) {
		return { type: authConstants.GET_USER_DATA_FAILURE, user };
	}
}

function getOnBoardingStatus(onboardingLoginEmail) {
	return (dispatch) => {
		dispatch(request({ onboardingLoginEmail }));
		authService.getOnBoardingStatus(onboardingLoginEmail).then((res) => {
			if (res.ok === true) {
				res.json().then((response) => {
					localStorage.removeItem('onboarding_email');
					localStorage.setItem('onboarding_email', onboardingLoginEmail);
					dispatch(success(response));
				});
			} else if (res.ok === false) {
				res.json().then((error) => {
					localStorage.removeItem('onboarding_email');
					dispatch(failure(error));
				});
			}
		});
	};

	function request(response) {
		return { type: authConstants.ONBOARDING_LOGIN_EMAIL_REQUEST, response };
	}
	function success(response) {
		return { type: authConstants.ONBOARDING_LOGIN_EMAIL_SUCCESS, response };
	}
	function failure(error) {
		return { type: authConstants.ONBOARDING_LOGIN_EMAIL_FAILURE, error };
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/auth.actions.js